import { Icon } from "@iconify/react";
import { subjects, plans } from "../data/plans-data";
import { Link, useParams } from "react-router-dom";
import scrollToTop from "./scrolltotop";

export function PlanCard({ planKey }) {
  const plan = plans[planKey];

  if (!plan) return null;

  let resolvedSubjects = [];
  let subjectText = "";

  if (plan.subjects && plan.subjects.length > 0) {
    resolvedSubjects = plan.subjects.map((id) => subjects[id]);
    subjectText = formatSubjects(resolvedSubjects);
  }

  const id = planKey.split("-")[0];

  return (
    <div className={`plan-card ${id} ${plan.name === "Maths, English & VR" ? "triocc" : ""}`}>
      <div className={`card-cont ${plan.name === "Maths, English & VR" ? "added" : ""}`}>
        <div className="ex">
          <h5 className="plan-title">{plan.name}</h5>
          <span className="title-underline"></span>
        </div>

        <div className="flow">
          {resolvedSubjects.length > 0 && (
            <div className="plan-subjects">
              <div className={`dots ${resolvedSubjects.length >= 3 ? "smalld" : ""}`}>
                {resolvedSubjects.map((s) => (
                  <span
                    key={s.label}
                    className={`dot ${resolvedSubjects.length >= 3 ? "small" : ""}`}
                    style={{ backgroundColor: s.lcolor }}
                  />
                ))}
              </div>

              <span className="subject-text">{subjectText}</span>
            </div>
          )}

          <div className="plan-info">
            <span>
              <Icon className="icon person" icon="bi-person-fill" />
              <p>{plan.population}</p>
            </span>
          </div>

          <div className="plan-info">
            <span>
              <Icon className="icon calendar" icon="uil-calendar" />
              <p>{plan.freq}</p>
            </span>
          </div>

          <div className="plan-info">
            <span>
              <Icon className="icon coins" icon="ph-coins-bold" />
              <p>{plan.cost}</p>
            </span>
          </div>
        </div>

        <Link to={`/courses/${plan.id}`} className="btn" onClick={scrollToTop}>
          Learn More
        </Link>
      </div>
    </div>
  );
}

function formatSubjects(subjects) {
  if (subjects.length === 1) return subjects[0].name;

  if (subjects.length === 2) {
    return `${subjects[0].name} & ${subjects[1].name}`;
  }

  return (
    subjects
      .slice(0, -1)
      .map((s) => s.name)
      .join(", ") +
    " & " +
    subjects[subjects.length - 1].name
  );
}

export function PlanCard2({ planKey }) {
  const plan = plans[planKey];
  const { slug } = useParams();

  if (!plan) return null;

  const baseId = plan.id.split("-")[0];

  return (
    <div className="plan-card2">
      {plan.record === "Small Group Boost" && (
        <div className="bestv">
          <p>Best Value</p>
        </div>
      )}

      <div className="card-cont">
        <p className="plan-title">{plan.record}</p>

        <div className="plan-info">
          <span>
            <Icon className="icon person" icon="bi-person-fill" />
            <p>{plan.population}</p>
          </span>
          <span>
            <Icon className="icon calendar" icon="uil-calendar" />
            <p>{plan.freq}</p>
          </span>
          <span>
            <Icon className="icon coins" icon="ph-coins-bold" />
            <p>{plan.cost}</p>
          </span>
        </div>

        <Link
          to="/getstarted"
          state={{
            course: slug,
            planId: baseId,
            planName: plan.name,
            population: plan.population,
            frequency: plan.freq,
            price: plan.cost,
          }}
          className="btn"
          onClick={scrollToTop}
        >
          Get Started
        </Link>
      </div>
    </div>
  );
}

export function PlanCard3({ planKey, subjectSlug }) {
  const plan = plans[planKey];
  if (!plan) return null;

  let resolvedSubjects = [];
  let subjectText = "";

  if (plan.subjects && plan.subjects.length > 0) {
    resolvedSubjects = plan.subjects.map((id) => subjects[id]);
    subjectText = formatSubjects(resolvedSubjects);
  }

  const id = planKey.split("-")[0];

  // Use the subjectSlug passed from the page
  const dColor = subjects[subjectSlug]?.dcolor || "";
  const lColor = subjects[subjectSlug]?.lcolor || "";

  return (
    <div
      className={`plan-card ${id} ${plan.name === "Maths, English & VR" ? "triocc" : ""}`}
    >
      <div
        className={`card-cont ${plan.name === "Maths, English & VR" ? "added" : ""}`}
        style={{ borderColor: lColor }}
      >
        <div className="ex">
          <h5 className="plan-title">{plan.name}</h5>
          <span
            className="title-underline"
            style={{ borderBottomColor: dColor }}
          ></span>
        </div>

        <div className="flow">
          {resolvedSubjects.length > 0 && (
            <div className="plan-subjects">
              <div
                className={`dots ${resolvedSubjects.length >= 3 ? "smalld" : ""}`}
              >
                {resolvedSubjects.map((s) => (
                  <span
                    key={s.label}
                    className={`dot ${resolvedSubjects.length >= 3 ? "small" : ""}`}
                    style={{ backgroundColor: s.lcolor }}
                  />
                ))}
              </div>

              <span className="subject-text">{subjectText}</span>
            </div>
          )}

          <div className="plan-info">
            <span>
              <Icon className="icon person" icon="bi-person-fill" />
              <p>{plan.population}</p>
            </span>
          </div>
          <div className="plan-info">
            <span>
              <Icon className="icon calendar" icon="uil-calendar" />
              <p>{plan.freq}</p>
            </span>
          </div>
          <div className="plan-info">
            <span>
              <Icon className="icon coins" icon="ph-coins-bold" />
              <p>{plan.cost}</p>
            </span>
          </div>
        </div>

        <Link
          to={`/courses/${plan.id}`}
          className="btn"
          style={{ backgroundColor: dColor }}
          onClick={scrollToTop}
        >
          Learn More
        </Link>
      </div>
    </div>
  );
}
